"use strict";
exports.__esModule = true;
exports.getSpectrumEventName = void 0;
function getSpectrumEventName(event) {
    var _a, _b;
    return (_b = (_a = event.event) === null || _a === void 0 ? void 0 : _a.$case) !== null && _b !== void 0 ? _b : "";
}
exports.getSpectrumEventName = getSpectrumEventName;
//# sourceMappingURL=spectrumUtils.js.map